import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBTable, MDBTableBody, MDBTableHead , } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Checkbox ,Flex ,Card  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';
import Loadding from './Loadding';
import logo from '../../img/logokpru.png'

const CheckboxGroup = Checkbox.Group;

export default class Modalexpercommentbacktexscore extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_comment:"",
   id_bn:"",
   statuscomment_bn:"",
   filewordcomment_bn:null,

   
   //send_uploadcommentepdfbn:null,

   nameuserbn:'',
   send_uploadewordbn:'',
   send_uploadepdfbn:'',

   idarticlebn:'',
   id_articlepsf:'', //id บทความ
   id_empex:'', //id ผู้ส่ง
   idarticleex:'',  //id บทความ
   expert_id:'' , //id กรรมการ
   typelevel:'',//ระดับ

   levelall:[],

   loadding:false,

   levelex:[], // ข้อมูลคะแนนแต่ละข้อ
   componentsex:[], //ข้อเสนอแนะ

   cm11:'',
   cm12:'',
   cm21:'',
   cm22:'',
   cm23:'',
   cm24:'',   
   cm31:'',   
   cm32:'',

   comment: [],

   scoreall : '',//สรุปผลประเมิน
   commentscoreall:'',//ข้อเสนอแนะผลการประเมิน


   checkedList: [],//ทดสอบ
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.setgrade2 = this.setgrade2.bind(this);
this.getlevels = this.getlevels.bind(this);
this.getcomment = this.getcomment.bind(this);
this.setcomment = this.setcomment.bind(this);
this.onTextChangecomment = this.onTextChangecomment.bind(this);
this.handleChangetotal = this.handleChangetotal.bind(this);
this.handleChangecommentscoreall = this.handleChangecommentscoreall.bind(this);
this.setgrade2all = this.setgrade2all.bind(this);
//this.CheckboxProps = this.CheckboxProps.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    loadding:true,
  });
  this.getExpert()
  this.getlevels()
  this.getcomment()

 //this.props.selectex();

 localStorage.getItem('presentype_id')
}

handleChangetype(event) {    this.setState({bn_commentbn: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_articlepsf:this.props.id_articlepsf,
                       id_empex:this.props.id_empex,
                       idarticleex:this.props.idarticleex,
                       typelevel:this.props.typelevel,
                       expert_id: localStorage.getItem('iduser'),
                       // send_uploadewordbn:this.props.send_uploadewordbn,
                     //   send_uploadepdfbn:this.props.send_uploadepdfbn,
                    //   id_bn:this.props.id_bn,
        })
  

  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       api.get('registercon/Selectcomponentspsf/'+this.props.typelevel)
      .then(res => {
       // console.log(res);
        
        this.setState({ loadding: false })
        this.setState({ levelall: res.data})
      }) 

    }, 0);

}


  getlevels() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       api.get('registercon/selectlevelex/'+this.props.typelevel)
      .then(res => {
      //  console.log(res.data);
        
       // this.setState({ loadding: false })
        this.setState({ levelex: res.data})
         this.setState({ checkedList: res.data})
      }) 

    }, 0);

}

  getcomment() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       api.get('registercon/selectsubcomponentsex/')
      .then(res => {
        console.log(res.data);
        
       // this.setState({ loadding: false })
        this.setState({ componentsex: res.data})
      }) 

    }, 0);

}

 onTextChangecomment  = (id) => e => {
// onTextChangecomment = (id,e) => {
        this.setState({ [e.target.name]: e.target.value })

                                                     const newShareholders = this.state.componentsex.map((std, sidx) => {
                                                      
                                                          if (id !== std.id_subcomponents) return std;
                                                          return { ...std, comments: e.target.value };
                                                        });
                                                    
                                                        this.setState({ componentsex : newShareholders });
    }


handleChange(event) {    this.setState({statusbn: event.target.value});  }
handleChangetotal(event) {    this.setState({scoreall: event.target.value});  }
handleChangecommentscoreall(event) {    this.setState({commentscoreall: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
handleChange2(event) {    this.setState({send_uploadcommentepdfbn: event.target.files[0]});  }


  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idarticlebn", this.state.idarticlebn);
      datafrm.append("id_articlepsf", this.state.id_articlepsf);
      datafrm.append("id_empbn", this.state.id_empbn);
      datafrm.append("statusbn", this.state.statusbn);
      datafrm.append("date_senbackbn", dates);
      datafrm.append("nameuserbn", this.state.nameuserbn); //.ใช้insert ผู้ทรง
      datafrm.append("send_uploadewordbn", this.state.send_uploadewordbn);
      datafrm.append("send_uploadepdfbn", this.state.send_uploadepdfbn);
       datafrm.append("dateaddex", dates);

      api.post("registercon/updatebncommentlist",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
             window.location.href = '/expertbn'
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })




}, 1000);

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }



//   handleSubmit() {
//     // alert('A name was submitted: ' + this.state.value);

//     const date = new Date();
//     const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
//     const dates = day+"-"+month+"-"+year ;

//    // console.log(dates)
//    setTimeout(() => {
//       const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
//       datafrm.append("idarticlebn", this.state.idarticlebn);
//       datafrm.append("id_articlepsf", this.state.id_articlepsf);
//       datafrm.append("id_empbn", this.state.id_empbn);
//       datafrm.append("bn_commentbn", this.state.bn_commentbn);
//       datafrm.append("statusbn", this.state.statusbn);
//       datafrm.append("send_uploadcommentepdfbn", this.state.send_uploadcommentepdfbn);
//       datafrm.append("date_senbackbn", dates);

      
//       api.post("registercon/Insertfilebncommentlistpsf",datafrm,{
//     headers: {
//         'content-type': 'multipart/form-data'
//     }
//    })

//    .then(res => {
   
  
//     if (res.data = '200') {
//         Swal.fire({
//          title: 'บันทึกข้อเสนอแนะสำเร็จ',
//          text: "Suggestion saved successfully",
//          icon: 'success',
//          showCancelButton: false,
//          confirmButtonColor: '#3085d6',
//          cancelButtonColor: '#d33',
//          confirmButtonText: 'ตกลง'
//        }).then((result) => {
//          if (result.isConfirmed) {
//              this.props.list()
//              this.toggle()
//          }
//        })
       
//        }else{
//              message.error("อัพโหลไฟล์ไม่สำเร็จ!")
//        }
//   })
// }, 1000);
//   }


 handleSubmit() {

 
    // alert('A name was submitted: ' + this.state.value);
//https://research.kpru.ac.th/research_new/Administrator_ResearchPublish/getpublic

Swal.fire({
  title: "ยืนยันผลการประเมิน",
  text: "ท่านยืนยันผลการประเมินและต้องการบันทึกข้อมูลหรือไม่",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "ยืนยัน",
  cancelButtonText: 'ยกเลิก'
}).then((result) => {
                                                                              

 if (result.isConfirmed) {

             this.setState({ loadding: true })                                                                      

    for (let index = 0; index < this.state.levelex.length; index++) {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); 
      datafrm.append("id_articlepsfck", this.state.id_articlepsf);
      datafrm.append("id_empexck", this.state.id_empex);
      datafrm.append("idarticleexck", this.state.idarticleex);
      datafrm.append("expert_idck", this.state.expert_id);
      
      datafrm.append("id_componentsck", this.state.levelex[index].id_components);
      datafrm.append("id_levelck", this.state.levelex[index].id_level);
      datafrm.append("id_subcomponentsck", this.state.levelex[index].id_subcomponents);
      datafrm.append("levelnameck", this.state.levelex[index].levelname);
      datafrm.append("leveltypeck", this.state.levelex[index].leveltype);
      datafrm.append("scoreck", this.state.levelex[index].score);

      datafrm.append("date_addck", dates);
     
          api.post("registercon/Insertlevelcheck/",datafrm,{
              headers: {
                  'content-type': 'multipart/form-data'
              }
            })

            
          .then(res => {
                if (res.status === 200) {
                      if (this.state.levelex.length === index+1) {
                        
                        //insert comment
                                   for (let indexs = 0; indexs < this.state.componentsex.length; indexs++) {

                                     const date = new Date();
                                     const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                                     const dates = day+"-"+month+"-"+year ;

                                    const datafrm = new FormData(); 
                                    datafrm.append("id_articlepsfcmck", this.state.id_articlepsf);
                                    datafrm.append("id_empexcmck", this.state.id_empex);
                                    datafrm.append("idarticleexcmck", this.state.idarticleex);
                                    datafrm.append("expert_idcmck", this.state.expert_id);

                                    datafrm.append("id_componentscmck", this.state.componentsex[indexs].id_components);
                                    datafrm.append("id_subcomponentscmck", this.state.componentsex[indexs].id_subcomponents);
                                  //  datafrm.append("subcomponents_namecmck", this.state.componentsex[indexs].subcomponents_name);
                                    datafrm.append("subcomponents_namecmck", '-');
                                    datafrm.append("commentscmck", this.state.componentsex[indexs].comments);

                                    datafrm.append("date_addcmck", dates);
                                

                                        api.post("registercon/Insertcommentcheck/",datafrm,{
                                            headers: {
                                                'content-type': 'multipart/form-data'
                                            }
                                          })

                                          
                                        .then(res => {
                                              if (res.status === 200) {
                                                    if (this.state.componentsex.length === indexs+1) {
                                                      
                                                                //สรุปผลประเมิน
                                                                  const date = new Date();
                                                                  const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                                                                  const dates = day+"-"+month+"-"+year ;

                                                                  const datafrm = new FormData(); 
                                                                  datafrm.append("id_articlepsfcr", this.state.id_articlepsf);
                                                                  datafrm.append("id_empexcr", this.state.id_empex);
                                                                  datafrm.append("idarticleexcr", this.state.idarticleex);
                                                                  datafrm.append("expert_idcr", this.state.expert_id);

                                                                  datafrm.append("scoreall", this.state.scoreall);
                                                                  datafrm.append("commentscoreall", this.state.commentscoreall);
                                                                  datafrm.append("date_addcr", dates);
                                                                 
                                                                      api.post("registercon/Insertscoreall/",datafrm,{
                                                                          headers: {
                                                                              'content-type': 'multipart/form-data'
                                                                          }
                                                                        })

                                                                        
                                                                      .then(res => {
                                                                            if (res.status === 200) {

                                                                                 this.setState({ loadding: false })
                                                                                
                                                                                      Swal.fire({
                                                                                            title: 'บันทึกข้อมูลสำเร็จ',
                                                                                            icon: 'success',
                                                                                          // showCancelButton: true,
                                                                                            confirmButtonText: 'ตกลง',
                                                                                          // cancelButtonText: 'No, keep it'
                                                                                          }).then((result) => {
                                                                                          this.props.list()
                                                                                          this.toggle()
                                                                                           window.location.href = '/expertexpsf'
                                                                                          })
                                                                                  
                                                                            }
                                                                      })  



                                                        // Swal.fire({
                                                        //       title: 'นำเข้าข้อมูลสำเร็จ',
                                                        //       icon: 'success',
                                                        //     // showCancelButton: true,
                                                        //       confirmButtonText: 'ตกลง',
                                                        //     // cancelButtonText: 'No, keep it'
                                                        //     }).then((result) => {
                                                            
                                                        //     })
                                                    }
                                              }
                                        })   
                                }




                          // Swal.fire({
                          //       title: 'นำเข้าข้อมูลสำเร็จ',
                          //       icon: 'success',
                          //       confirmButtonText: 'ตกลง',
                          //     }).then((result) => {
                              
                          //     })
                      }
                }
          })   
     }
 

    }else{
      this.setState({ loadding: false })
      this.toggle();
      
    }
  })
//ปิดswit

        
  }







 setgrade2 = index => evt => {
                console.log(evt.target.checked)
                console.log(index)
               

                                                     const newShareholders = this.state.levelex.map((levelex, sidx) => {
                                                      
                                                          if (index !== levelex.id_level) return levelex;
                                                          return { ...levelex, score: Number(evt.target.checked) };
                                                        });
                                                    
                                                        this.setState({ levelex: newShareholders });


                                                    //  const newShareholdersall = this.state.levelall.map((levelall, index) => {
                                                      
                                                    //      {
                                                    //         this.state.levelall[index].std.map((std, indexstd) => {
                                                    //                   {
                                                    //                      this.state.levelall[index].std[indexstd].mainlevel.map((mainlevel, indexmainlevel) => {
                                                    //                         {
                                                    //                           this.state.levelall[index].std[indexstd].mainlevel[indexmainlevel].map((level, indexlevel) => {
                                                    //                                  if (index !== level.id_level) return levelall;
                                                    //                                   return { ...levelall, score: Number(evt.target.checked) };
                                                    //                            })
                                                    //                         }
                                                    //                      })
                                                    //                   }
                                                    //         })
                                                    //      }
                                                      
                                                    // });
                                                    const newShareholdersall = this.state.levelall.map((levelall) => ({
                                                        ...levelall,
                                                        std: levelall.std.map((std) => ({
                                                          ...std,
                                                          mainlevel: std.mainlevel.map((mainlevel) => ({
                                                            ...mainlevel,
                                                            level: mainlevel.level.map((lvl) => {
                                                              // เช็ก id_level ให้ตรงกับเงื่อนไขที่ต้องการ (เช่น ค่า id จาก event หรือ target)
                                                              // หมายเหตุ: หากเทียบกับ targetId ให้เปลี่ยน targetLevelId เป็น id ที่ส่งมา
                                                              if (lvl.id_level !== index) return lvl;

                                                              // อัปเดตค่า ck หรือ score ตามที่ต้องการ
                                                              return {
                                                                ...lvl,
                                                                ck: Number(evt.target.checked) , // หรือใช้ score: Number(evt.target.checked)
                                                              };
                                                            })
                                                          }))
                                                        }))
                                                      }));
                                                    this.setState({ levelall: newShareholdersall });



 }

 onCheckAllChange = index => evt => {
   // setCheckedList(e.target.checked ? plainOptions : []);
    console.log(evt.target.checked)
    console.log(index)

    // this.setState({
    //   checkedList: evt.target.checked ?this.state.levelex : [],
    // });



                                                         const newShareholders = this.state.levelex.map((levelex, sidx) => {
                                                      
                                                          if (index !== levelex.id_subcomponents) return levelex;
                                                          return { ...levelex, score: Number(evt.target.checked) };
                                                        });
                                                    
                                                        this.setState({ levelex: newShareholders });



                                                    const newShareholdersall = this.state.levelall.map((levelall) => ({
                                                        ...levelall,
                                                        std: levelall.std.map((std) => ({
                                                          ...std,
                                                          mainlevel: std.mainlevel.map((mainlevel) => ({
                                                            ...mainlevel,
                                                            level: mainlevel.level.map((lvl) => {
                                                              // เช็ก id_level ให้ตรงกับเงื่อนไขที่ต้องการ (เช่น ค่า id จาก event หรือ target)
                                                              // หมายเหตุ: หากเทียบกับ targetId ให้เปลี่ยน targetLevelId เป็น id ที่ส่งมา
                                                              if (lvl.id_subcomponents !== index) return lvl;

                                                              // อัปเดตค่า ck หรือ score ตามที่ต้องการ
                                                              return {
                                                                ...lvl,
                                                                ck: Number(evt.target.checked) , // หรือใช้ score: Number(evt.target.checked)
                                                              };
                                                            })
                                                          }))
                                                        }))
                                                      }));
                                                    this.setState({ levelall: newShareholdersall });
                                                       
 

  }

 setgrade2all  = (id, e)  => {
                console.log(e.target.value)
                console.log(id)
                console.log(this.state.typelevel)

                                                     const newShareholders = this.state.levelex.map((levelex, sidx) => {
                                                      
                                                          if (id !== levelex.id_subcomponents ) return levelex;
                                                          return { ...levelex, score: Number(1) };
                                                        });
                                                    
                                                        this.setState({ levelex: newShareholders });

 }



 // setcomment = event => id => {
  setcomment  = (indexstd, id) => event => {
                console.log(event.target.value)
                console.log(id)
                console.log(indexstd)

                console.log(this.state.levelall[indexstd].std[0].subcomponents_name)
               

                                                    //  const newShareholders = this.state.levelall[events].std.map((std, sidx) => {
                                                      
                                                    //       if (id !== std.id_components) return std;
                                                    //       return { ...std, comments: event.target.value };
                                                    //     });
                                                    
                                                    //     this.setState({ levelall[events] : newShareholders });



                                                    const newShareholders = this.state.levelall[indexstd].std.map((std, sidx) => {
                                                        if (id !== std.id_components) return std;
                                                        return { ...std, comments: event.target.value };
                                                    });

                                                   

   console.log(newShareholders)

                                                 

 }
  

    render() {

       console.log(this.state.componentsex);
       console.log(this.state.levelex)
       console.log(this.state.levelall)
      // console.log(this.state.id_send)
      
    const  checkedList  = this.state.levelex;
    // คำนวณสถานะ Check All และ Indeterminate ในฟังก์ชัน render
    const checkAll = this.state.levelex.length === checkedList.length;
    const indeterminate = checkedList.length > 0 && checkedList.length < this.state.levelex.length;

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>ประเมินผลงาน</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size='fluid'>
              <MDBModalHeader toggle={this.toggle}>
              ประเมินผลงาน
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>
{ this.state.loadding === true ?<>
<Loadding/>
</>:<>
 {/* <div >  
 <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/>
    </div> */}
<h3 className='text-center'>แบบประเมินตามระดับของแนวทางการพัฒนาคุณภาพอาจารย์เพื่อส่งเสริมการบรรลุผลลัพธ์การเรียนรู้</h3>
<h5>ชื่อผู้ขอรับการประเมิน : {this.props.nameuserex}</h5>
<h5>ระดับที่ขอรับการประเมิน : ระดับที่ {this.state.typelevel}</h5>
 

 {this.state.levelall.map((levelall,index )  => 
      <>
             <p> {index+1}.{levelall.components_name} </p>
             
            {this.state.levelall[index].std.map((std,indexstd )  => 
                   <>
                  
                    <Card  variant="borderless" style={{ width: '100%' }}>
                       {/* <MDBBtn color="primary" onClick={(e) => this.setgrade2all(std.id_subcomponents, e)} size='sm' >เลือกทั้งหมด</MDBBtn> */}
                       <div className='text-right'>

                                 <Checkbox
          indeterminate={indeterminate}
          onChange={this.onCheckAllChange(std.id_subcomponents)}
          className='text-right'
         // checked={checkAll}
        >
          เลือกทั้งหมด
        </Checkbox>
                       </div>
          
                              <MDBTable bordered responsive small>
                                <MDBTableHead color="blue-grey lighten-3" textWhite>
                                    <tr>
                                    <th>องค์ประกอบคุณภาพ</th>
                                      {this.state.levelall[index].std[indexstd].mainlevel.map((mainlevel,indexmainlevel )  => 
                                      <th>{mainlevel.mainlevel_name}</th>
                                       )}
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                    <tr>
                                    <td>{std.subcomponents_name}{std.id_subcomponents}</td>
                                     {this.state.levelall[index].std[indexstd].mainlevel.map((mainlevel,indexmainlevel )  => 
                                      <td>
                                         
                                              {this.state.levelall[index].std[indexstd].mainlevel[indexmainlevel].level.map((level,indexlevel )  => 
                                             <>
                                                    {level.ck === 1 ?<>
                                                       <p><Checkbox checked="checked" onChange={this.setgrade2(level.id_level)} value={this.state.levelex} >{level.levelname} {level.score}</Checkbox></p>

                                                    </> :<>
                                                    {level.ck === 0 ?<>
                                                     <p><Checkbox  onChange={this.setgrade2(level.id_level)} value={this.state.levelex} >{level.levelname} {level.score}</Checkbox></p>
                                                    </>:<>
                                                     <p><Checkbox  onChange={this.setgrade2(level.id_level)} value={this.state.levelex} >{level.levelname} {level.score}</Checkbox></p>
                                                    </> }
                                                      

                                                    </> }
                                             </>
                                            // <p><CheckboxGroup  onChange={this.setgrade2(level.id_level)}  >{level.levelname}</CheckboxGroup ></p>  
                                            //  <p>{this.state.levelex[indexlevel].id_level}/ {level.id_level} {level.levelname}</p>
                                                )}
                                          
                                      </td>
                                       )}
                                    
                                    </tr>
                                
                                </MDBTableBody>
                                </MDBTable>

{/* {this.state.levelall[index].std[indexstd].id_subcomponents} */}
{/* cm11 */}
                               
                                 
                                          {this.state.levelall[index].std[indexstd].id_subcomponents == '1' ?<>
                                          <div className="mb-2">
                                              <label><strong>ข้อเสนอแนะ</strong></label>
                                              <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm11"
                                                  value={this.state.cm11} placeholder="ข้อเสนอแนะ" required />
                                          </div>
                                          <br/>
                                          </>:<>
                                          
                                          </>}

                                          {this.state.levelall[index].std[indexstd].id_subcomponents == '2' ?<>
                                          <div className="mb-2">
                                              <label><strong>ข้อเสนอแนะ</strong></label>
                                              <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm12"
                                                  value={this.state.cm12} placeholder="ข้อเสนอแนะ" required />
                                          </div>
                                          <br/>
                                          </>:<>
                                          
                                          </>}

                                             {this.state.levelall[index].std[indexstd].id_subcomponents == '3' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm21"
                                                      value={this.state.cm21} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              </>:<>
                                              
                                              </>}

                                            {this.state.levelall[index].std[indexstd].id_subcomponents == '4' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm22"
                                                      value={this.state.cm22} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              </>:<>
                                              
                                              </>}


                                               {this.state.levelall[index].std[indexstd].id_subcomponents == '5' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm23"
                                                      value={this.state.cm23} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              </>:<>
                                              
                                              </>}

                                                {this.state.levelall[index].std[indexstd].id_subcomponents == '6' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm24"
                                                      value={this.state.cm24} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              </>:<>
                                              
                                              </>}

                                                 {this.state.levelall[index].std[indexstd].id_subcomponents == '7' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm31"
                                                      value={this.state.cm31} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              </>:<>
                                              
                                              </>}

                                               {this.state.levelall[index].std[indexstd].id_subcomponents == '8' ?<>
                                              <div className="mb-2">
                                                  <label><strong>ข้อเสนอแนะ</strong></label>
                                                  <textarea className="form-control" onChange={this.onTextChangecomment(this.state.levelall[index].std[indexstd].id_subcomponents)} name="cm32"
                                                      value={this.state.cm32} placeholder="ข้อเสนอแนะ" required />
                                              </div>
                                              <br/>
                                              <p></p>
                                              </>:<>
                                              
                                              </>}
                                      
                              </Card>
                   </>

// (e) => handleInputChange(e, customId)

            )}


<hr/>
                      
    </>
      
  )}
<h4>สรุปผลการประเมิน</h4>

<h5>ชื่อผู้ขอรับการประเมิน : {this.props.nameuserex}</h5>
<h5>ระดับที่ขอรับการประเมิน : ระดับที่ {this.state.typelevel}</h5>
              <div className="mb-2">
               <label><strong>ผลการประเมิน</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChangetotal}>
                        <option>------กรุณาเลือกผลการประเมิน------</option>
                        <option value="2">ผ่าน</option>
                        <option value="4">ผ่านโดยมีข้อเสนอแนะเพิ่มเติม</option>
                        <option value="3">รอพิจารณา</option>
                        <option value="0">ไม่ผ่าน </option>
                </select>
                </div>
 {/* 1 = ส่ง , 2 = ผ่าน , 0 = ไม่ผ่าน 3 = รอพิจารณา  4 = ผ่านโดยมีข้อเสนอแนะเพิ่มเติม     */}



          {this.state.scoreall =='4'?<>
                              <div className="mb-2">
                                    <label><strong>ข้อเสนอแนะ</strong></label>
                                    <textarea className="form-control" onChange={this.handleChangecommentscoreall} name="comment_bn"
                                              value={this.state.comment_bn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
                                </div>
              </>:<>
              
              </>}


</>}
   

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
               {/* <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="2">ผ่าน</option>
                        <option value="0">ปรับแก้ไข</option>
                </select>
                </div> */}

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}
           

{/* {this.state.statusbn === '2' ?<>

</>:<>

{this.state.statusbn === '0' ?<>
                           <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.bn_commentbn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
                           </div>

                           <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมิน .pdf <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required />
                            </div>

</>:<></>}
</>} */}
               
                      
            
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
               
                {this.state.scoreall !== ''?<>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                </>:<>
                  <MDBBtn color="primary" disabled >บันทึก</MDBBtn>
                </>}

                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


